<template>
  
  <div class="con_content">
       <div class="container">
            <div class="container_top h_48">系统设置</div>
           

           
            <div class="my_table   my_body    padlr20">
               <Tabs type="card">
                    <TabPane label="基础设置">
                         <ul class='my_ul'>
                            <li v-for="(item,num) in data1" :key="num">
                                <div class='li_lft' >
                                    {{item.name}} :
                                </div>
                                <div class='li_rgt' >
                                    <Input disabled ref='isFocuseA'      class='ipt'  placeholder="请输入网站名称"  v-model="item.value"  clearable/>
                                </div>
                            </li>
                            
                           


                            
                            
                        </ul>
                    </TabPane>
                    <!-- <TabPane label="SEO管理">

                    </TabPane>
                    <TabPane label="开关设置">

                    </TabPane> -->
                    
                </Tabs>
            </div>

        </div>
        
    </div>
</template>

<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    import { format } from 'path';
    
    export default {
        
        name:'system',
        data () {
            return {
                // vuex
                token:'', 
                mobile: '' ,
                data1: null
            }    
        },
       
        
        
       
        methods: {
           load1(){
               var that = this;
               that.$myAjax.get('admin/service/admin/system/config').then(function(res){
                   that.data1 = res.data.data;
                //    console.log(that.data1)
               })
               
                

               
             
           },
            
            succ1(){

            }
           
            
        },
        mounted: function(){
           var that = this;
           
            that.token = that.$store.state.token;
            that.guid = that.$store.state.guid;
            that.load1();
           
            
        }
    }
</script>
<style scoped>
 @import "/css/li_input.css" 
  
    
</style>




